import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// axios
// 在main.js中 导入 axios，在组件中使用时不需要再进行导入
import axios from 'axios'
// 全局配置 axios 的请求根路径
// axios.defaults.baseURL = 'http://api-sie.zlygu.com/api'
// axios.defaults.baseURL = 'http://admin.test.com/api'
let path = '/api'
let url = window.location.origin +path
axios.defaults.baseURL = url
// 把axios挂载到Vue的原型上
Vue.prototype.$http = axios
// 在每个vue组件中要发起请求，直接调用this.$http.xxx
// 缺点：无法实现 api 的复用s

//将公共方法挂载this
import fun from './common/common.js'
Vue.prototype.$fun = fun;
// rem
import './router/rem'

// icon
import './assets/font/iconfont.css'
// total
import './router/total.css'
// 屏幕滚动（首页）
// import 'fullpage.js/dist/fullpage.css';
// import 'fullpage.js/vendors/scrolloverflow';
import './router/fullpage.css';
import './router/scrolloverflow'
import VueFullPage from 'vue-fullpage.js';
Vue.use(VueFullPage);

// 点击放大图片
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)

// swiper
import "swiper/swiper.min.css"


// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
